import { Button } from '@ytl/common-web';
import { useLanguage } from '../contexts/languageContext';

export const RealmSwitchView = () => {
  const { translation } = useLanguage();

  return (
    <>
      <h3 dangerouslySetInnerHTML={{ __html: translation.loginRegister.login.realmSwitch.header }} />
      <p>{translation.loginRegister.login.realmSwitch.message}</p>
      <Button
        variant={'contained'}
        onClick={() => {
          const search = new URLSearchParams(window.location.search);
          search.delete('_rs');
          const qs = search?.toString();
          const query = qs?.length > 0 ? `?${qs}` : '';
          window.location.href = window.location.origin + window.location.pathname + query;
        }}
      >
        {translation.loginRegister.login.realmSwitch.action}
      </Button>{' '}
    </>
  );
};
